
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";

import { Head } from "@/components/Head";
import { ContentSection } from "@/sections/ContentSection";

const RefundPolicy = () => {
  return (
    <>
      <Head
        pageNamespace="page/refundPolicy"
        ogImage="/images/refund-og-image.jpg"
      />
      <ContentSection title="Refund Policy">
        <h2>General</h2>
        <p>
          Magicul converts design files into different formats to save you the
          time to re-create them manually. Our highest priority is for all
          converted files to look as visually identical as possible. We've built
          our file converters with that in mind. In some edge-cases, you may
          experience issues with your converted file. Read more about when
          you're eligible for a refund.
        </p>
        <h2>Refund Eligibility</h2>
        <p>
          In some cases, your converted file might have some slight differences
          from the original file. We understand that you expect the results to
          be as accurate as possible. We kindly ask you to reach out to our
          customer support team first and describe the upcoming problem. We will
          then internally file a bug report and get the issues resolved by our
          development team. For most problems, we should be able to provide a
          solution within 24 hours.
        </p>
        <p>
          If we can not provide a solution to the reported problem within 72
          hours, we will issue a refund. For credit or subscription customers,
          we will re-issue all lost credits.
        </p>
        <p>
          To be eligible for a full refund on a credit package or a subscription
          the refund request has to be submitted before converting more than 2
          files.
        </p>
        <h2>Backup Subscriptions (Figma, Airtable & Miro Backup)</h2>
        <p>
          Our backup products run on a subscription basis. Before purchasing a
          paid plan, you can test the service for free — for example, our Figma
          backup tool lets you back up one file at no cost — so you can verify
          that backups work for your setup.
        </p>
        <p>
          If a scheduled backup fails or a backup cannot be restored, please
          contact our support team first. If we cannot provide a solution within
          72 hours, we will refund the current billing period.
        </p>
        <p>
          You can request a full refund of your first subscription payment
          within 14 days of the initial purchase. Subscriptions can be cancelled
          at any time and remain active until the end of the paid billing
          period; renewal payments are not refunded once a new billing period
          has started, unless the service failed as described above.
        </p>
        <h2>Refund Time Limit</h2>
        <p>
          You can request a refund as long as it’s within 14 days after your
          initial purchase.
        </p>
        <h2>Refund Procedure</h2>
        <p>
          You can request a refund within 14 days after your initial payment.
          Once this period has elapsed, we can always assist with any issues
          that may have come up. In order to request a refund, simply send an
          email to support@magicul.io.
        </p>
        <h2>Confidentiality of your data</h2>
        <p>
          We take data privacy very seriously. Your files won't be accessed or
          edited manually. Even when filing a bug report, your files will be
          handled fully confidential. You can read more about our data privacy
          guidelines here:
          https://help.magicul.io/en/articles/5578636-data-privacy-guidelines-at-xd2sketch.
        </p>
        <h2>Refund Processing Time</h2>
        <p>
          Right after a refund has been processed, you will receive an automated
          confirmation email. In most cases, your refund should show up in your
          account within 3 to 5 business days. Depending on your card issuer the
          time it takes for the money to show up on your card may vary.
        </p>
      </ContentSection>
    </>
  );
};

export default RefundPolicy;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/refund-policy',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  